import React from "react";

// Image \\
import discount from "../../assets/images/discount.jpg";

// Style \\
import "../../assets/styles/card/discountCard.scss";

const DiscountCard = () => {
  return (
    <div className="box">
      <div class="cardDis">
        <img src={discount} alt="" />
        <div class="card-content">
          <p className="">
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nesciunt
            exercitationem iste, voluptatum, quia explicabo laboriosam rem
            adipisci voluptates cumque, veritatis atque nostrum corrupti ipsa
            asperiores harum? Dicta odio aut hic.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DiscountCard;
